import type { TruckModelEntity } from '@/libs/api'

export const mapToTruckModelFieldName = (truckModel: TruckModelEntity) => {
  return `${truckModel.code}/${truckModel.name}`
}
